import { styled } from "../../styles"
import { boxCss } from "../../Box"

const StyledContainer = styled.div({
  ...boxCss,
  position: `relative`,
  display: `inline-block`,
  width: `100%`,
})

export default StyledContainer
